import { TableProps } from 'antd';
import React from 'react';

import ResizableTable from '../../../foundation/components/resizable_table/ResizableTable';
import CollapsePanel from '../components/CollapsePanel';
import { VariantChangelogType } from '../redux';

type VariantChangelogProps = {
  changelogs?: VariantChangelogType[];
};
const VariantChangelog = ({ changelogs = [] }: VariantChangelogProps) => {
  const columns: TableProps<VariantChangelogType>['columns'] = [
    {
      title: 'Changed on',
      dataIndex: 'changed',
      key: 'changed',
    },
    {
      title: 'Changed by',
      dataIndex: 'changed_by',
      key: 'changed_by',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
  ];

  return (
    <CollapsePanel
      title={<h3 className="c-collapse-title">Changelog</h3>}
      panelKey="variant_changelog"
    >
      <ResizableTable
        columns={columns}
        dataSource={changelogs}
        rowKey={(record) => `${record.id}-${record.changed}`}
        persistenceKey="variant-changelog"
      />
    </CollapsePanel>
  );
};

export default VariantChangelog;
